window.app_models.budget_item = {
    "id":null,
    "date": null,
    "account":null,
    "cost":null,
    "budget_item_type":"furniture",
    "budget_id":null,
    "vendor_id":null
};


// WEBPACK FOOTER //
// ./resources/assets/js/models/budget_item.js